import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-LC-logo",
  "use": "icon-LC-logo-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-LC-logo\"><defs><style type=\"text/css\"></style></defs><path d=\"M143.36 921.6V716.8h532.48l204.8 204.8H143.36z\" fill=\"#FFFFFF\" p-id=\"734\" /><path d=\"M143.36 307.2V102.4h737.28L675.84 307.2H143.36z\" fill=\"#00BCBF\" p-id=\"735\" /><path d=\"M348.16 921.6H143.36V102.4l204.8 204.8v614.4z\" fill=\"#FFFFFF\" p-id=\"736\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol